import { TABLE_COLORS } from '../../globalStyle/colors';
import { css } from '@emotion/core';


export const ROW_STYLE = css`
  padding: 16px 10px;
  line-height: 22px;
  text-align: start;
  
  border-left: 1px solid ${TABLE_COLORS.BORDER};
  border-top: 1px solid ${TABLE_COLORS.BORDER};

  &:last-of-type {
    border-right: 1px solid  ${TABLE_COLORS.BORDER};
  }
`;

export const TABLE_STYLE = css`
  border-spacing: 0;
  width: 100%;
  font-size: 12px;
  
  thead tr {
    font-weight: bold;
    align-items: center;
    background-color:  ${TABLE_COLORS.DARK_BG};
  }
  
  tbody tr {
    background-color: ${TABLE_COLORS.LIGHT_BG};
    
    &:nth-of-type(odd) {
      background-color:  ${TABLE_COLORS.DARK_BG};
    }
    
    &:last-of-type {
      td {
        border-bottom: 1px solid ${TABLE_COLORS.BORDER};
      }
    }
  }
  
  th {
    ${ROW_STYLE};
  }
  
  td {
    ${ROW_STYLE};
  }
`;
